<ag-grid-angular
  style="width: 100%; height: 120px;"
  class="ag-theme-alpine"
  [rowData]="rosterValues"
  [columnDefs]="gridHeaders"
  [gridOptions]="gridOptions">
</ag-grid-angular>    
